var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteprimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete-icon-primary",
    transform: "translate(3024 -2075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1361",
    "data-name": "Rectangle 1361",
    width: 24,
    height: 24,
    transform: "translate(-3024 2075)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.831,13.328a.833.833,0,0,0,.833-.833v-5A.833.833,0,1,0,5,7.5v5a.833.833,0,0,0,.833.833Zm8.33-10H10.829V2.5A2.5,2.5,0,0,0,8.33,0H6.664a2.5,2.5,0,0,0-2.5,2.5v.833H.833A.833.833,0,1,0,.833,5h.833v9.163a2.5,2.5,0,0,0,2.5,2.5h6.664a2.5,2.5,0,0,0,2.5-2.5V5h.833a.833.833,0,1,0,0-1.666ZM5.831,2.5a.833.833,0,0,1,.833-.833H8.33a.833.833,0,0,1,.833.833v.833H5.831Zm5.831,11.662a.833.833,0,0,1-.833.833H4.165a.833.833,0,0,1-.833-.833V5h8.33Zm-2.5-.833A.833.833,0,0,0,10,12.5v-5a.833.833,0,1,0-1.666,0v5a.833.833,0,0,0,.833.833Z",
    transform: "translate(-3019.497 2078.67)",
    fill: "#227c9d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteprimary);
export default __webpack_public_path__ + "static/media/Deleteprimary.701ab372e6193cd02d63b4cfc2c8f571.svg";
export { ForwardRef as ReactComponent };